import {BaseInputType} from "@renta-apps/athenaeum-react-common";
import {
  BaseRegexValidator,
  BaseRegexValidatorErrorMessage,
  TextInput,
  ValidatorCallback
} from "@renta-apps/athenaeum-react-components";
import { InputValidationRule } from "@/models/Enums";

export class PhoneValidator extends BaseRegexValidator {
  constructor() {
    super(InputValidationRule.Phone, BaseRegexValidatorErrorMessage.validatorsPhoneLanguageItemName);
  }

  public static readonly instance: PhoneValidator = new PhoneValidator();

  public static readonly validator: ValidatorCallback<string> = (value: string | null) => PhoneValidator.instance.validate(value);
}

export default class PhoneInput extends TextInput {
  protected getType(): BaseInputType {
    return BaseInputType.Text;
  }

  public getValidators(): ValidatorCallback<string>[] {
    return [PhoneValidator.validator];
  }
}